// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1OiYY","actionsCol":"EnrolledClinics_actionsCol__3h6iN"};